<div style="background: #F5F5F5; padding: 16px;" *ngIf="!strategyId">
  <div class="row page-title-bar" style="margin-bottom: 16px;">
    <div class="medium-12 title">Templates</div>
  </div>
  <div class="row"  style="background: #FFFFFF;">
    <div class="column large-4 medium-4 small-4" style="font-size: 14px !important;margin-bottom: 5px;">
    </div>
    <div class="column large-8 medium-8 small-8" style="font-size: 14px !important;margin-bottom: 5px;">
      <div class="float-right pointer" style="margin: 10px 10px;color: #1570EF;display: inline-flex;" (click)="addNewTemplate()">
        <i class="material-icons">add</i><span style="position: relative;top: 2px;">Create a new Template</span>
      </div>
    </div>
  </div>
  <div class="row preferences client-todos tax-planning-clients" style="background: #FFFFFF;padding-left: 0px;">
    <div class="column large-12 medium-12 small-12 foo-container icons-table" style="padding: 0;">
      <div class="tab-container books-tab-container">
        <div class="collapse tab-content clients-data">
          <div class="indy-tables badge-tables tooltip-overflow">
            <app-tracker-paginated-table [setObj]="templatesTableData" *ngIf="hasTemplatesList" (onScroll)="handleScroll($event)" (onRowAction)="handleAction($event)"
                                     (onSort)="sortByColumn($event)" (onRowClick)="handleRowClick($event)"></app-tracker-paginated-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="strategyId">
  <div class="row preferences client-todos tax-planning-clients" style="background: #FFFFFF;padding-left: 0px;">
    <div class="column large-12 medium-12 small-12 foo-container icons-table" style="padding: 0;">
      <div class="tab-container books-tab-container">
        <div class="collapse tab-content clients-data">
          <div class="indy-tables badge-tables tooltip-overflow">
            <app-tracker-paginated-table [setObj]="templatesTableData" *ngIf="hasTemplatesList" (onScroll)="handleScroll($event)" (onRowAction)="handleAction($event)"
                                     (onSort)="sortByColumn($event)" (onRowClick)="handleRowClick($event)"></app-tracker-paginated-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['addOrEditTemplate']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addOrEditTemplate']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 70%;" [ngClass]="{'tpiq-reveal': reveal['addOrEditTemplate']}">
    <div class="body" style="padding: 15px;height: 90vh;">
      <app-create-or-update-template [editMode]="editMode" [templateId]="templateId" (onCancelCreateOrUpdateOfTemplate)="hideReveal('addOrEditTemplate')"
                                   (onCreationOrUpdateOfTemplate)="refreshListOfTemplates()"></app-create-or-update-template>
    </div>
  </div>
</div>

<div *ngIf="reveal['showNotes']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['showNotes']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 85%;" [ngClass]="{'tpiq-reveal': reveal['showNotes']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Template Notes</span>
      <span class="float-right pointer" (click)="hideReveal('showNotes')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>

    <div class="body" style="padding: 15px;">
      <div class="row">
        <div class="medium-12 columns">
          <label>
            <div style="border:1px solid #cacaca;padding:10px;margin-bottom:20px;" [froalaEditor]="editorOptions" [(froalaModel)]="template.notes"></div>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button class="button small float-right" (click)="updateNotesForTemplate()">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['viewTemplate']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['viewTemplate']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 80%;" [ngClass]="{'tpiq-reveal': reveal['viewTemplate']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Template Info</span>
      <span class="float-right pointer" (click)="hideReveal('viewTemplate')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <app-template-info [templateId]="templateId"></app-template-info>
    </div>
  </div>
</div>
